import { FOOTER } from "@/content";

export const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="wrap">
      <span>{FOOTER.text}</span>
      <a
        href={FOOTER.instagram.href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-instagram-link"
      >
        {FOOTER.instagram.label}
      </a>
    </div>
  </footer>
);
